import { isMeetPagePath, MEET_PAGE_ENABLED } from "config/featureFlags";

/**
 * Internal site path or external URL for events with a dedicated page
 * instead of an expandable details panel on /events.
 *
 * Contentful `events` → `detailPageLink` (Short text), e.g. `/bourbon-city-spectacular`
 */
export const getEventDetailLink = (fields = {}) => {
  const link = fields.detailPageLink;

  if (typeof link === "string" && link.trim()) {
    const trimmed = link.trim();
    if (MEET_PAGE_ENABLED || !isMeetPagePath(trimmed)) {
      return trimmed;
    }
  }

  return null;
};

export const isInternalEventLink = (link) =>
  Boolean(link && link.startsWith("/") && !link.startsWith("//"));
